// removed by extract-text-webpack-plugin
module.exports = {"list":"c-ProductsList__list"};


//////////////////
// WEBPACK FOOTER
// ./src/components/container/ProductsList/ProductsList.scss
// module id = 534
// module chunks = 0